import DOMPurify from 'dompurify'

export default {
  install (Vue) {
    Vue.prototype.$DOMPurify = DOMPurify
    Vue.prototype.$sanitize = (html) => DOMPurify.sanitize(html)
  }
}
